<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-pt-md q-pb-lg' : 'q-py-lg']">
    <div :class="['row col-11 justify-between items-start', isMobile ? '' : 'q-px-sm']">

      <!-- support campaign (desktop) -->
      <div :class="['side-panel col-12 col-md-3 column', isMobile ? 'order-last q-mb-xs' : undefined]">

        <!-- overall info -->
        <campaign-item-mobile
          v-if="!isMobile"
          class="full-width q-mb-md"
          :clickable="false"
          :extra-details="true"
          :show-description="false"
          :favorite="true"
          :id="campaign.id"
          :limited="campaign.isLimited"
          :charity-logo="campaign.charityLogo"
          :title="campaign.title"
          :charity-title="campaign.charityTitle"
          :is-favorite="userLikedPost"
          :description="campaign.description"
          :progress="campaign.progress"
          :involvement-rate="campaign.involvementRate"
          :money-raised="campaign.incomeAmount"
          :estimated-cost="campaign.estimatedCost"
          :remaining-days="campaign.remainingDays"
          :sponsor-count="campaign.sponsorCount"
          :status="campaign.statusLookup"
          @toggleFavorite="toggleFavorite"
        />

        <div v-if="!isMobile" class="column border-radius border-solid bg-white q-py-md text-grey-4">

          <!-- title -->
          <div class="text-subtitle1 text-bold text-grey-9 q-mb-md q-px-md">
            {{ campaign.statusLookup === 1 ? 'حمایت می‌کنم' : 'پایان یافته' }}
          </div>

          <!-- body -->
          <div class="row full-width">

            <!-- in-effect state -->
            <div v-if="campaign.statusLookup === 1" class="column full-width q-gutter-y-md">

              <!-- preset prices -->
              <div class="row full-width q-px-md justify-between items-center">
                <div v-for="(price, index) of prices" :key="index" class="col-4">
                  <div
                    :class="['column border-radius border-solid q-mx-xs q-pa-xs items-center cursor-pointer hover-primary', price.amount === donationPrice / 10 ? 'text-primary' : 'text-grey-6']"
                    @click="donationPrice = price.amount * 10">

                    <!-- price -->
                    <div
                      :class="['text-h6 text-weight-regular', price.amount === donationPrice / 10 ? 'text-primary' : '']">
                      {{ (price.amount / 1000).toNumber() }}
                    </div>

                    <!-- unit -->
                    <div class="text-subtitle2 text-weight-regular">
                      هزار تومان
                    </div>

                  </div>
                </div>
              </div>

              <!-- price input -->
              <div class="row full-width q-mb-sm q-px-md">
                <div class="row full-width border-radius border-solid q-px-md hover-primary" style="border: 2px solid">
                  <q-input class="full-width" input-class="text-h5 text-center text-grey-8"
                           :model-value="donationPrice.toNumber()"
                           dir="ltr" prefix="مبلغ" suffix="﷼" borderless @update:model-value="onInputPrice"/>
                </div>
              </div>

              <!-- written price -->
              <div class="row full-width q-mt-none q-mb-sm q-px-md justify-center">
                <div
                  :class="['text-subtitle2 text-weight-regular', donationPrice < 50000 ? 'text-red-13' : 'text-positive']">
                  {{ donationPrice > 10 ? (donationPrice / 10).NumToText() + ' تومان' : '' }}
                </div>
              </div>

              <!-- anonymous donation -->
              <div class="row q-mt-none q-px-md q-gutter-x-sm items-center cursor-pointer"
                   @click="anonymousDonation = !anonymousDonation">

                <!-- checkbox -->
                <q-checkbox v-model="anonymousDonation" :color="anonymousDonation ? 'primary' : 'grey-5'" keep-color
                            dense/>

                <!-- title -->
                <div class="text-subtitle1 text-weight-light text-grey-8">
                  پرداخت به صورت ناشناس
                </div>

              </div>

              <!-- pay -->
              <div class="row full-width q-px-md">
                <q-btn class="full-width border-radius text-weight-light" size="lg" color="primary" label="پرداخت"
                       unelevated @click="validatePrice"/>
              </div>

            </div>
            <!-- in-effect state -->

            <!-- finished state -->
            <div v-else class="column full-width q-gutter-y-md">

              <!-- description -->
              <div class="row full-width q-px-md">
                <div class="text-subtitle2 text-weight-regular text-justify text-grey-8">
                  {{
                    campaign.statusLookup === 3 || campaign.isLimited === 0 ? 'این پویش با موفقیت به پایان رسید.' : 'این پویش با عدم کسب حد نساب به پایان رسید.'
                  }}
                </div>
              </div>

              <!-- view reports, results -->
              <div class="row full-width q-px-md">

                <!-- view reports -->
                <div class="col-6 q-pr-sm">
                  <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary" label="گزارشات"
                         unelevated @click="changeTab('report')"/>
                </div>

                <!-- view results -->
                <div class="col-6 q-pl-sm">
                  <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary" label="نتایج"
                         unelevated @click="changeTab('results')"/>
                </div>

              </div>

              <!-- view other projects -->
              <div class="row full-width q-px-md">
                <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary"
                       label="سایر پروژه‌ها" outline @click="$router.push('/challenges')"/>
              </div>

            </div>
            <!-- finished state -->

          </div>

        </div>

      </div>

      <!-- details -->
      <div :class="['row col-12 col-md-9', isMobile ? undefined : 'q-pl-md']">

        <!-- overall info -->
        <campaign-item-mobile
          v-if="isMobile"
          class="full-width q-mb-md"
          :clickable="false"
          :extra-details="true"
          :show-description="false"
          :favorite="true"
          :id="campaign.id"
          :limited="campaign.isLimited"
          :charity-logo="campaign.charityLogo"
          :title="campaign.title"
          :charity-title="campaign.charityTitle"
          :is-favorite="userLikedPost"
          :description="campaign.description"
          :progress="campaign.progress"
          :involvement-rate="campaign.involvementRate"
          :money-raised="campaign.incomeAmount"
          :estimated-cost="campaign.estimatedCost"
          :remaining-days="campaign.remainingDays"
          :sponsor-count="campaign.sponsorCount"
          :status="campaign.statusLookup"
          @toggleFavorite="toggleFavorite"
        />

        <!-- tab menus -->
        <div :class="['bg-grey-2 q-mb-md tabs full-width', isMobile ? 'q-pt-md' : undefined]">
          <q-card :class="['full-width border-radius', isMobile ? '' : undefined]"
                  style="border: 1px solid lightgrey"
                  flat>
            <q-tabs
              :model-value="tab"
              active-color="primary"
              indicator-color="primary"
              :breakpoint="0"
              align="justify"
              narrow-indicator
              mobile-arrows
              outside-arrows
              @update:model-value="changeTab"
            >
              <q-tab name="description" label="درباره ‌پویش" :ripple="false"/>
              <q-tab name="supporters" label="حامیان مالی" :ripple="false"/>
              <q-tab name="report" label="گزارش پویش" :ripple="false"/>
              <q-tab name="results" label="نتایج" :ripple="false"/>
            </q-tabs>
          </q-card>
        </div>

        <!-- tabs -->

        <!-- description -->
        <div v-if="tab === 'description'" :class="['row full-width', isMobile ? 'q-mb-md' : undefined]">

          <!-- description -->
          <div v-if="campaign.description"
               class="row full-width border-radius border-solid bg-white q-pa-md text-grey-4">
            <div class="full-width text-grey-8 ck-content" v-html="campaign.description"></div>
          </div>

          <!-- share on social media -->
          <div class="row full-width q-my-md justify-end">
            <div class="row q-gutter-x-md items-center">

              <!-- info -->
              <div class="text-subtitle2 text-weight-regular text-black">
                اشتراک‌ گذاری سریع
              </div>

              <!-- telegram-->
              <a :href="`https://telegram.me/share/url?url=${pageUrl}`" target="_blank" style="text-decoration: none">
                <q-icon class="text-grey-9 hover-primary" name="la la-telegram" size="26px">
                  <q-tooltip class="border-radius bg-black text-caption">
                    تلگرام
                  </q-tooltip>
                </q-icon>
              </a>

              <!-- whatsapp -->
              <a :href="`https://web.whatsapp.com/send?text=${pageUrl}`" target="_blank"
                 style="text-decoration: none">
                <q-icon class="text-grey-9 hover-primary" name="la la-whatsapp" size="26px">
                  <q-tooltip class="border-radius bg-black text-caption">
                    واتس اپ
                  </q-tooltip>
                </q-icon>
              </a>

            </div>
          </div>

          <!-- comments -->
          <div class="column full-width">

            <!-- title -->
            <div class="text-subtitle1 text-bold text-black">
              نظرات
            </div>

            <!-- comments -->
            <div class="full-width q-my-md">
              <div class="column full-width q-gutter-y-md">

                <!-- if comments exist -->
                <comment-item v-if="comments && comments.length > 0" v-for="comment of comments"
                              :comment="comment"/>

                <!-- otherwise -->
                <div v-else class="row full-width">
                  <div class="text-subtitle2 text-weight-regular text-black">
                    هنوز نظری ثبت نشده است
                  </div>
                </div>

              </div>
            </div>

            <!-- post comment -->
            <div class="full-width border-radius border-solid bg-white text-grey-4 q-pa-md">
              <div class="column full-width q-gutter-y-md">

                <!-- title -->
                <div class="row full-width">
                  <div class="text-subtitle2 text-bold text-black">
                    ثبت نظر
                  </div>
                </div>

                <!-- rating -->
                <div class="row full-width justify-between items-center">

                  <!-- info -->
                  <div class="text-subtitle2 text-weight-regular text-grey-8">
                    چه امتیازی می‌دهید؟
                  </div>

                  <!-- rating -->
                  <q-rating v-model="userComment.rating" color="primary" size="1rem" icon="la la-star"
                            icon-half="la la-star-half" dir="ltr" :disable="!loggedIn"/>

                </div>

                <!-- text -->
                <div class="row full-width">
                  <q-input v-model="userComment.text" class="full-width" input-style="min-height: 100px"
                           label="متن نظر" type="textarea" :maxlength="500" :disable="!loggedIn" autogrow
                           outlined dense/>
                </div>

                <!-- submit -->
                <div class="row full-width justify-between items-center">

                  <!-- disclaimer (not logged in) -->
                  <div class="col q-pr-md">
                    <div v-if="!loggedIn" class="row q-gutter-x-sm items-center">

                      <!-- icon -->
                      <q-icon name="la la-lightbulb" size="sm" color="black"/>

                      <!-- info -->
                      <div class="text-subtitle2 text-weight-regular text-grey-8">
                        برای ثبت نظر ابتدا
                      </div>

                      <!-- login / register -->
                      <router-link
                        class="cursor-pointer text-subtitle2 text-bold text-black hover-primary"
                        style="text-decoration: none" tag="div" :to="`/login?fallbackUrl=${currentPath}`">
                        وارد شوید
                      </router-link>

                    </div>
                  </div>

                  <!-- submit -->
                  <div class="col-auto">
                    <q-btn class="full-width border-radius q-px-lg text-weight-regular" color="primary" label="ثبت نظر"
                           :disable="!loggedIn" unelevated dense @click="submitComment"/>
                  </div>

                </div>

              </div>
            </div>

          </div>

        </div>

        <!-- supporters -->
        <div v-if="tab === 'supporters'"
             :class="['row full-width items-stretch q-gutter-y-sm', isMobile ? 'q-mb-md justify-between' : '']">

          <!-- support this campaign -->
          <div v-if="campaign.statusLookup === 1 && !userHasDonated" class="col-6 col-md-2"
               :style="{'min-height' : isMobile ? '178px' : '156px'}">
            <div
              :class="['column full-height border-radius border-solid bg-cyan-1 items-center q-mx-xs q-pa-md text-secondary cursor-pointer']"
              @click="$router.push(`/donate/${campaign.tenantId}/${id}`)"
            >

              <!-- avatar -->
              <q-avatar class="text-h6 text-bold text-white" color="secondary" :size="isMobile ? '70px' : '60px'">
                ش
              </q-avatar>

              <!-- text -->
              <div :class="['text-secondary', isMobile ? 'text-subtitle2 q-mt-md' : 'text-subtitle2 q-mt-md']">
                شما
              </div>

              <!-- support -->
              <div :class="['text-secondary', isMobile ? 'text-subtitle2 q-mt-md' : 'text-subtitle2 q-mt-xs']">
                کلیک کنید
              </div>

            </div>
          </div>

          <!-- supporters -->
          <q-intersection v-for="(sponsor, index) of campaign.sponsors" :key="index"
                          class="col-6 col-md-2" :style="{'min-height' : isMobile ? '178px' : '156px'}" tag="div"
                          transition="scale">
            <div
              :class="['column border-radius border-solid items-center q-mx-xs q-pa-md', sponsor.id === userId ? 'bg-cyan-1 text-secondary' : 'bg-white text-grey-4']">

              <!-- avatar -->
              <q-avatar class="text-h6 text-white"
                        :style="{'background-color': sponsor.id === userId ? undefined : getColor()}"
                        :size="isMobile ? '70px' : '60px'" :color="sponsor.id === userId ? 'secondary' : undefined">
                {{ sponsor.id === userId ? 'ش' : sponsor.title.charAt(0) }}
              </q-avatar>

              <!-- name -->
              <div
                :class="[sponsor.id === userId ? 'text-secondary' : 'text-grey-8', isMobile ? 'text-subtitle2 q-mt-md' : 'text-subtitle2 q-mt-md']">
                {{ sponsor.id === userId ? 'شما' : sponsor.title }}
              </div>

              <!-- donation amount -->
              <div :class="['text-positive', isMobile ? 'text-subtitle2 q-mt-md' : 'text-subtitle2 q-mt-xs']">
                {{ sponsor.amount.toString().substring(0, sponsor.amount.toString().length)?.toMoney() }}
              </div>

            </div>
          </q-intersection>

        </div>

        <!-- report -->
        <div v-if="tab === 'report'" class="full-width q-gutter-y-md">

          <!-- if reports exist -->
          <div v-if="campaign.reports" v-for="(report, index) of campaign.reports"
               :class="['full-width border-radius border-solid bg-white q-pa-md text-grey-4', isMobile ? 'q-mb-lg' : undefined]">
            <div class="column full-width q-gutter-y-md">

              <!-- title, date -->
              <div class="row full-width border-radius bg-grey-3 q-pa-md justify-between items-center cursor-pointer"
                   :id="`report-${report.id}`"
                   @click="handleReportVisibility(index, report.id)"
              >

                <!-- title -->
                <div :class="['text-grey-9', isMobile ? 'text-subtitle2' : 'text-subtitle1']">
                  {{ report.title }}
                </div>

                <!-- date -->
                <div class="row items-center text-grey-8">

                  <!-- icon (desktop) -->
                  <q-icon v-if="!isMobile" name="la la-calendar" size="sm"/>

                  <!-- date -->
                  <div :class="['row', isMobile ? 'text-caption' : 'q-ml-sm text-subtitle2']">
                    {{ report.date.toJalaliFullDate() }}
                  </div>

                </div>

              </div>

              <!-- description -->
              <div v-show="activeReport === index"
                   class="text-grey-8 ck-content full-width" v-html="report.description"/>

            </div>
          </div>

          <!-- otherwise -->
          <div v-else class="row full-width border-radius border-solid bg-white q-pa-md text-grey-4">
            <div class="text-subtitle2 text-weight-regular text-grey-8">
              هنوز گزارشی برای این پویش ثبت نشده است.
            </div>
          </div>

        </div>

        <!-- results -->
        <div v-if="tab === 'results'" :class="['row full-width', isMobile ? 'q-mb-md' : undefined]">

          <!-- if results exist -->
          <div v-if="reports.length > 0" class="column full-width q-gutter-y-md">
            <div v-for="(report, index) of reports">

              <!-- support pack info -->
              <div
                :class="['row full-width border-radius border-solid bg-white text-grey-4 overflow-hidden', activeSupportPackDetails !== null && index === activeSupportPackDetails ? 'q-mb-md' : undefined]"
                :id="index"
              >

                <!-- date -->
                <div
                  :class="['row col-12 col-md-2 bg-primary justify-center items-center text-white', isMobile ? 'q-py-md' : undefined]">

                  <!-- year -->
                  <div :class="['row justify-center items-center', isMobile ? 'col-4 order-last' : 'col-12 q-pt-sm']">
                    <div :class="['text-bold', isMobile ? 'text-h5' : 'text-subtitle2']">
                      {{ getYear(report.supportPackDate) }}
                    </div>
                  </div>

                  <!-- day -->
                  <div :class="['row justify-center items-center', isMobile ? 'col-4 order-first' : 'col-12 q-pt-sm']">
                    <div class="text-h5 text-bold">
                      {{ getDay(report.supportPackDate) }}
                    </div>
                  </div>

                  <!-- month -->
                  <div :class="['row justify-center items-center', isMobile ? 'col-4' : 'col-12 q-pb-sm']">
                    <div class="text-subtitle1 text-weight-regular">
                      {{ report.supportPackDate?.getJalaliMonth() }}
                    </div>
                  </div>

                </div>

                <!-- title, supported families count -->
                <div :class="['row col-12 col-md-7 q-px-md', isMobile ? 'q-pt-md q-pb-sm' : 'q-py-md']">

                  <!-- title -->
                  <div :class="['row col-12', isMobile ? 'q-mb-sm justify-center' : undefined]">
                    <div
                      :class="['text-weight-regular text-grey-9', isMobile ? 'text-subtitle1 text-center' : 'text-subtitle1']">
                      {{ report.supportPackTitle }}
                    </div>
                  </div>

                  <!-- supported families count -->
                  <!--                  <div :class="['row col-12 items-center', isMobile ? 'justify-center' : undefined]">-->

                  <!--                    &lt;!&ndash; icon, title &ndash;&gt;-->
                  <!--                    <div-->
                  <!--                      :class="['row col-12 col-md-auto items-center text-grey-7', isMobile ? 'q-mb-xs justify-center' : undefined]">-->

                  <!--                      &lt;!&ndash; icon &ndash;&gt;-->
                  <!--                      <q-icon :class="isMobile ? 'col-12 q-mb-xs' : 'q-pb-xs'" name="la la-user-friends"-->
                  <!--                              :size="isMobile ? 'xl' : 'sm'"/>-->

                  <!--                      &lt;!&ndash; title &ndash;&gt;-->
                  <!--                      <div :class="['text-subtitle2', isMobile ? undefined : 'q-ml-sm']">-->
                  <!--                        {{ isMobile ? 'دریافت‌کنندگان' : 'دریافت‌کنندگان :' }}-->
                  <!--                      </div>-->

                  <!--                    </div>-->

                  <!--                    &lt;!&ndash; count &ndash;&gt;-->
                  <!--                    <div :class="['row col-12 col-md items-center', isMobile ? 'justify-center' : 'q-pl-sm']">-->
                  <!--                      <div :class="['text-bold text-secondary', isMobile ? 'text-h6' : 'text-subtitle2']">-->
                  <!--                        {{ report?.families?.length }}-->
                  <!--                      </div>-->
                  <!--                    </div>-->

                  <!--                  </div>-->

                </div>

                <!-- donated amount, show/hide details -->
                <div
                  :class="['row col-12 col-md-3 justify-center', isMobile ? 'border-dashed-top q-pa-md' : 'border-dashed-right q-pa-md']">

                  <!-- icon, title -->
                  <div
                    :class="['row col-12 col-md-auto justify-center items-center text-grey-7', isMobile ? 'q-mb-xs' : undefined]">

                    <!-- icon -->
                    <q-icon :class="isMobile ? 'col-12 q-mb-xs' : 'q-pb-xs'" name="la la-coins"
                            :size="isMobile ? 'xl' : 'sm'"/>

                    <!-- title -->
                    <div :class="['text-subtitle2', isMobile ? undefined : 'q-ml-sm']">
                      میزان مشارکت
                    </div>

                  </div>

                  <!-- amount -->
                  <div class="row col-12 q-my-sm justify-center items-center">
                    <div :class="['text-bold text-positive', isMobile ? 'text-h6' : 'text-subtitle1']">
                      {{ (report.amount).toFixed(0).toMoney() }}
                    </div>
                  </div>

                  <q-btn class="col-12 border-radius text-weight-regular" color="primary" label="جزییات بیشتر"
                         unelevated dense @click="openDetails(index, report.supportPackId )"/>

                </div>

              </div>

              <!-- families details -->
              <div v-if="index === activeSupportPackDetails" class="row full-width q-gutter-y-sm">
                <q-inner-loading :showing="areFamiliesLoading">
                  <q-spinner-dots/>
                </q-inner-loading>
                <q-intersection v-for="(family, i) of report.families" :key="i"
                                :class="['col-12 col-md-4', isMobile ? undefined : 'q-px-xs']"
                                tag="div" transition="scale" style="height: 254px">
                  <div
                    class="column border-radius border-solid bg-white q-pl-none q-py-md text-grey-4">
                    <div class="column q-gutter-y-md">

                      <!-- family number -->
                      <div class="row full-width q-px-md">
                        <div class="text-subtitle2 text-bold text-grey-8">
                          {{ 'پرونده شماره ' + family.familyNumber }}
                        </div>
                      </div>

                      <!-- family members -->
                      <div class="row full-width q-px-md line-clamp-2" style="height: 44px">
                        <span class="text-subtitle2 text-weight-regular text-grey-7 text-justify">

                          <!-- title -->
                          <span class="text-subtitle2 text-grey-8">
                            شامل:
                          </span>

                          <!-- members -->
                          {{ family.familyDescription ? family.familyDescription : 'نامشخص' }}

                        </span>
                      </div>

                      <!-- coverage -->
                      <div class="row full-width q-px-md">
                        <span class="text-subtitle2 text-weight-regular text-grey-7 text-justify">

                          <!-- title -->
                          <span class="text-subtitle2 text-grey-8">
                            علت پوشش:
                          </span>

                          <!-- coverage -->
                          {{ family.coverageLookupTitle ? family.coverageLookupTitle : 'نامشخص' }}

                        </span>
                      </div>

                      <!-- received items -->
                      <div class="row full-width q-px-md hover-overflow">
                        <span class="text-subtitle2 text-weight-regular text-grey-7 q-gutter-y-xs">

                          <!-- title -->
                          <span class="text-subtitle2 text-grey-8">
                            اقلام دریافتی:
                          </span>

                          <!-- items -->
                          <span v-for="item of family.supportPackItems" class="col-auto q-pr-xs">
                            <q-chip color="cyan-1" :ripple="false" dense>

                              <!-- quantity -->
                              <q-avatar color="cyan-2" text-color="blue-10">
                                {{ item.quantity }}
                              </q-avatar>

                              <!-- product -->
                              <div class="text-caption text-weight-regular text-grey-9 q-mx-xs">
                                {{ item.productTitle }}
                              </div>

                            </q-chip>
                          </span>

                        </span>
                      </div>

                    </div>
                  </div>
                </q-intersection>
              </div>

            </div>
          </div>

          <!-- otherwise -->
          <div v-else class="row full-width border-radius border-solid bg-white q-pa-md text-grey-4">
            <div class="text-subtitle2 text-weight-regular text-grey-8">
              موردی برای نمایش یافت نشد.
            </div>
          </div>

        </div>

        <!-- tabs -->

      </div>

      <!-- invalid price dialog -->
      <q-dialog ref="invalidPriceDialog">
        <div class="row bg-white q-py-md" style="border-radius: 10px !important">
          <div class="column q-gutter-y-md">

            <!-- header -->
            <div class="full-width q-px-md">
              <div class="row border-radius bg-red-1 q-px-md q-py-sm justify-between items-center text-primary">

                <!-- title -->
                <div class="text-subtitle1 text-weight-regular">
                  خطا
                </div>

                <!-- icon -->
                <q-icon name="la la-exclamation-circle" size="sm"/>

              </div>
            </div>

            <!--            <q-separator inset/>-->

            <!-- body -->
            <div class="q-px-md">
              <div class="text-body2 text-grey-9">
                حداقل مبلغ قابل پرداخت 50,000 ریال می باشد.
              </div>
            </div>

            <!--            <q-separator inset/>-->

            <!-- footer -->
            <div class="q-px-md">
              <q-btn class="full-width border-radius text-subtitle1 text-weight-regular" color="secondary"
                     label="متوجه شدم" outline dense @click="$refs.invalidPriceDialog.hide"/>
            </div>

          </div>
        </div>
      </q-dialog>

      <!-- support campaign (mobile) -->
      <q-page-sticky v-if="isMobile && campaign.statusLookup === 1" position="bottom" expand>
        <q-btn class="full-width no-border-radius q-py-md text-subtitle1 text-weight-regular"
               :color="campaign.statusLookup === 1 ? 'green-13' : 'cyan'"
               :label="campaign.statusLookup === 1 ? 'حمایت مالی' : 'پایان یافته'"
               unelevated dense
               @click="campaign.statusLookup === 1 ? $router.replace(`/donate/${campaign.tenantId}/${id}`) : supportCampaignDialog = true"/>
      </q-page-sticky>

      <!-- support campaign dialog -->
      <q-dialog :model-value="supportCampaignDialog" style="z-index: 100000" maximized>
        <div
          :class="['column full-width full-height bg-white q-px-md justify-center', campaign.statusLookup === 1 ? 'q-py-md' : 'q-py-sm']">

          <!-- in-effect state -->
          <div v-if="campaign.statusLookup === 1" class="column full-height q-gutter-y-md">

            <!-- title, close dialog -->
            <div class="row full-width q-px-xs justify-between items-center">

              <!-- title -->
              <div class="text-subtitle1">
                حمایت می‌کنم
              </div>

              <!-- close dialog -->
              <q-btn class="border-radius" size="13px" icon="la la-times" color="grey-6" unelevated dense
                     @click="supportCampaignDialog = false"/>

            </div>

            <!-- campaign name -->
            <div class="row full-width justify-center">
              <div class="text-subtitle1 text-weight-regular">
                {{ campaign.title }}
              </div>
            </div>

            <!-- info -->
            <div class="row full-width justify-center">
              <div class="text-subtitle2 text-weight-light">
                مبلغ موردنظر خود را انتخاب و یا وارد کنید
              </div>
            </div>

            <!-- preset prices -->
            <div class="row full-width justify-between items-center">
              <div v-for="(price, index) of prices" :key="index" class="col-4">
                <div
                  :class="['column border-radius border-solid q-mx-xs q-pa-xs items-center cursor-pointer hover-primary', price.amount === donationPrice ? 'text-primary' : 'text-grey-6']"
                  @click="donationPrice = price.amount">

                  <!-- price -->
                  <div class="text-h6 text-weight-regular">
                    {{ (price.amount / 100).toNumber() }}
                  </div>

                  <!-- unit -->
                  <div class="text-subtitle2">
                    هزار تومان
                  </div>

                </div>
              </div>
            </div>

            <!-- price input -->
            <div class="row full-width q-px-xs">
              <div
                :class="['row full-width border-radius border-solid q-px-md', inputActive === true ? 'border-active' : 'border-inactive text-grey-6']">
                <q-input class="full-width text-subtitle1 text-weight-light"
                         input-class="text-h5 text-weight-light text-center text-grey-8"
                         :model-value="donationPrice.toNumber()" suffix="﷼"
                         dir="ltr" borderless @update:model-value="onInputPrice" @click="inputActive = true"
                         @focusout="inputActive = false"/>
              </div>
            </div>

            <!-- pay -->
            <div class="row full-width q-px-xs">
              <q-btn class="full-width border-radius text-weight-light" size="lg" color="primary" label="پرداخت"
                     unelevated @click="pay"/>
            </div>

          </div>
          <!-- in-effect state -->

          <!-- finished state -->
          <div v-else class="column full-height q-gutter-y-lg">

            <!-- title, close dialog -->
            <div class="row col-auto full-width q-px-xs justify-between items-center">

              <!-- title -->
              <div class="text-subtitle1">
                پایان یافته
              </div>

              <!-- close dialog -->
              <q-btn class="border-radius" size="13px" icon="la la-times" color="grey-6" unelevated dense
                     @click="supportCampaignDialog = false"/>

            </div>

            <!-- image -->
            <div class="row col-auto full-width q-px-md justify-center">
              <div style="width: 90%; height: 90%">
                <q-img class="border-radius" src="img/finished.svg"/>
              </div>
            </div>

            <!-- description -->
            <div class="row col-auto full-width q-px-xs justify-center">
              <div class="text-subtitle1 text-weight-regular text-justify text-grey-8">
                {{
                  campaign.statusLookup === 2 ? 'این پویش با موفقیت به پایان رسید.' : 'این پویش با عدم کسب حد نساب به پایان رسید.'
                }}
              </div>
            </div>

            <!-- view reports, results -->
            <div class="row col-auto full-width q-px-xs">

              <!-- view reports -->
              <div class="col-6 q-pr-sm">
                <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary" label="گزارشات"
                       unelevated
                       @click="supportCampaignDialog = false; changeTab('report')"/>
              </div>

              <!-- view results -->
              <div class="col-6 q-pl-sm">
                <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary" label="نتایج"
                       unelevated @click="supportCampaignDialog = false; changeTab('results')"/>
              </div>

            </div>

            <!-- view other projects -->
            <div class="row col-auto full-width q-px-xs">
              <q-btn class="full-width border-radius text-weight-regular q-py-sm" color="primary" label="سایر پروژه‌ها"
                     outline
                     @click="$router.push('/challenges')"/>
            </div>

          </div>
          <!-- finished state -->

        </div>
      </q-dialog>

    </div>
  </div>
</template>

<script>
import CampaignItem from "../components/CampaignItem";
import * as moment from "jalali-moment";
import {LocalStorage, useMeta} from "quasar";
import CampaignItemMobile from "../components/CampaignItemMobile";
import CommentItem from "../components/CommentItem";

export default {
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    await store.dispatch('loadCampaign', currentRoute.params.id)
    let meta = {}
    let title = store.state.tenant.title
    const result = store.state.preFetch.campaign
    if (result == null) redirect('/404')
    if (store.state.tenant.id === process.env.HAMIANE_TENANT_ID) {
      meta.title = 'حامیانه | ' + result.charityTitle + ' | مشارکت در پویش ' + result.title
    } else {
      meta.title = `${title} | مشارکت در پویش ${result.title}`
    }
    meta.description = result.description?.htmlToText()
    meta.script = null
    await store.dispatch('loadProjectSupportPacks', currentRoute.params.id)
    return await store.dispatch('setMeta', meta)
  },
  name: "ProjectInfo",
  components: {
    CampaignItemMobile,
    CampaignItem,
    CommentItem
  },
  data: () => ({
    alternateTab: 'description',
    isLoading: false,
    areFamiliesLoading: false,
    baseUrl: process.env.API_URL,
    campaignSlide: 0,
    activeReport: 0,
    activeSupportPackDetails: null,
    reportId: null,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    commentText: null,
    captcha: null,
    donationPrice: 0,
    anonymousDonation: false,
    supportCampaignDialog: false,
    inputActive: false,
    userHasDonated: false,
    userLikedPost: false,
    thumbStyle: {
      height: '0px'
    },
    userComment: {
      rating: 3,
      text: ''
    },
    comments: [],
    prices: [
      {amount: 5000},
      {amount: 50000},
      {amount: 500000}
    ],
    colors: ['#f44336', '#2196f3', '#8bc34a', '#ff5722', '#e91e63', '#03a9f4', '#cddc39', '#795548', '#9c27b0', '#00bcd4', '#673ab7', '#009688', '#ffc107', '#3f51b5', '#4caf50', '#ff9800'],

  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    loggedIn() {
      return this.$store.state.user
    },
    currentPath() {
      if (this.$route.fullPath)
        return encodeURIComponent(this.$route.fullPath)
      else return encodeURIComponent("")
    },
    id() {
      return this.$route.params.id
    },
    tab() {
      return this.$route.query.tab || this.alternateTab
    },
    userId() {
      return parseInt(this.$store.state.user?.sub) || -1
    },
    campaign() {
      return this.$store.state.preFetch.campaign
    },
    reports() {
      return this.$store.state.preFetch.projectSupportPacks
    },
    pageUrl() {
      return `https://hamiane.com/donate/${this.campaign.tenantId}/${this.id}`
    }
  },
  methods: {
    async loadDetails() {
      this.isLoading = true
      const res = await this.$axios.get(`${process.env.API_URL}/charity/Project/details/${this.id}`)
      this.campaign = res.data.result
      this.isLoading = false
    },
    async loadComments() {
      const res = await this.$axios.get(`${process.env.API_URL}/cms/comment/list`, {
        params: {
          serviceName: 'charity',
          modelName: 'project',
          entityId: this.id
        }
      })
      this.comments = res.data.result
    },
    async submitComment() {
      await this.$axios.post(`${process.env.API_URL}/cms/comment/submit`, {
        serviceName: 'charity',
        modelName: 'project',
        entityId: this.id,
        text: this.userComment.text,
        rating: this.userComment.rating
      })
      this.userComment.rating = 3
      this.userComment.text = ''
    },
    // async loadReports() {
    //   const res = await this.$axios.get(`${process.env.API_URL}/charity/Project/supportPacks/${this.id}`)
    //   this.reports = res.data.result
    // },
    async openDetails(index, supportPackId) {
      this.areFamiliesLoading = true
      await this.$store.dispatch('loadFamilies', {index: index, supportPackId: supportPackId})
      this.areFamiliesLoading = false
      this.activeSupportPackDetails = index
      this.scrollToElement(index)
    },
    getYear(date) {
      return moment(date).format('jYYYY')
    },
    getDay(date) {
      return moment(date).format('jDD')
    },
    getColor() {
      let index = Math.floor(Math.random() * (15 + 1))
      return this.colors[index]
    },
    async handleReportVisibility(index, id) {
      if (this.activeReport == null) {
        this.reportId = id
        this.activeReport = index
        await this.$router.replace({
          path: this.$route.fullPath,
          query: {
            tab: this.$route.query.tab,
            reportId: id
          }
        })
      } else {
        if (this.activeReport === index) {
          this.reportId = null
          this.activeReport = null
          await this.$router.replace({
            path: this.$route.fullPath,
            query: {
              tab: this.$route.query.tab,
              reportId: this.reportId
            }
          })
        } else {
          this.reportId = id
          this.activeReport = index
          await this.$router.replace({
            path: this.$route.fullPath,
            query: {
              tab: this.$route.query.tab,
              reportId: id
            }
          })
        }
      }
    },
    onInputPrice(evt) {
      let res = parseInt(evt.toString().replaceAll(',', ''))
      this.donationPrice = isNaN(res) || res < 0 ? 0 : res
    },
    validatePrice() {
      if (this.donationPrice < 50000) {
        this.$refs.invalidPriceDialog.show()
      } else {
        let charityId = this.$store.state.preFetch.campaign.tenantId
        let projectId = this.$store.state.preFetch.campaign.id
        this.$router.push({path: `/donate/${charityId}/${projectId}`, query: {donationAmount: this.donationPrice}})
      }
    },
    scrollToElement(id) {
      let element = document.getElementById(id)
      setTimeout(() => element.scrollIntoView({behavior: 'smooth', block: 'nearest'}), 100)
    },
    async changeTab(tab) {
      this.alternateTab = tab
      if (tab === 'report') {
        await this.$router.replace({
          path: this.$route.fullPath,
          query: {
            tab: tab,
            reportId: this.campaign.reports && this.campaign.reports.length > 0 ? this.reportId ? this.reportId : 0 : null
          }
        })
      } else await this.$router.replace({path: this.$route.fullPath, query: {tab: tab}})
      // if (this.$q.platform.is.cordova)
      //   this.$router.replace({path: this.$route.path, query: {tab}})
    },
    async checkFavorite() {
      if (this.$store.state.user) {
        const res = await this.$axios.get(`${process.env.API_URL}/Tenant/Favorite/check`, {
          params: {
            serviceName: 'charity',
            modelName: 'project',
            entityId: this.id
          },
          noNotify: true
        })
        this.userLikedPost = res.data.result
      } else {

      }
    },
    async toggleFavorite() {
      if (this.$store.state.user) {
        await this.$axios.post(`${process.env.API_URL}/Tenant/Favorite/toggle`, {
          serviceName: 'charity',
          modelName: 'project',
          entityId: this.id
        }, {noNotify: true})
        await this.checkFavorite()
      } else {

      }
    }
  },
  async mounted() {
    useMeta(this.$store.state.meta)
    await this.loadComments()
    let anonymousDonation = LocalStorage.getItem('anonymousDonation')
    if (anonymousDonation != null) {
      this.anonymousDonation = anonymousDonation
    }
    await this.checkFavorite()
    this.$store.commit('setPageLoadState', true)
    this.reportId = this.campaign.reports && this.campaign.reports[0].id
    setTimeout(() => {
      if (this.$route.query.tab === 'report' && this.$route.query.reportId) {
        this.reportId = +this.$route.query.reportId
        this.activeReport = this.campaign.reports && this.campaign.reports.findIndex(x => x.id === +this.$route.query.reportId)
        this.scrollToElement(`report-${+this.$route.query.reportId}`)
      }
    }, 1000)
    if (this.campaign.sponsors.find(user => user.id === this.userId)) {
      this.userHasDonated = true
    }
  },
  watch: {
    anonymousDonation(to, from) {
      LocalStorage.set('anonymousDonation', to)
    },
    id(from, to) {
      if (to !== null && this.$route.name === 'projectInfo')
        this.loadDetails()
    }
  }
}
</script>

<style scoped>
img {
  display: flex;
  margin: auto;
  border-radius: 10px;
}

.side-panel {
  position: sticky;
  top: 82px;
}

.border-dashed-right {
  border-left: 2px dashed lightgrey
}

.border-dashed-top {
  border-top: 2px dashed lightgrey
}

.hover-overflow {
  transition: 0.3s;
  height: 82px;
  overflow: hidden;
}

.hover-overflow:hover {
  transition: 0.3s;
  height: fit-content;
  background-color: white;
  box-shadow: 0 0 5px #e1e1e1;
  border-radius: 5px;
  padding: 10px;
  z-index: 10;
}

.q-timeline__subtitle {
  opacity: 1;
}

.tabs {
  position: sticky;
  z-index: 100;
  top: 49px;
}
</style>
